import { makeStyles } from "@material-ui/core/styles";

export const useTabsStyles = makeStyles(() => ({
  tabBar: {
    display: "flex",
    flexDirection: "column",
    margin: "0 2rem 2rem",
    width: "100%",
  },
  appBar: {
    backgroundColor: "white",
    borderBottom: "1px solid #e9e9e9",
    boxShadow: "none",
    color: "black",
    fontSize: "16px",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  tab: {
    fontSize: "15px",
    "&.Mui-selected": {
      fontWeight: "bold",
    },
    "&:hover": {
      color: "#00CAFF",
      fontWeight: "bold",
    },
  },
  selectionContainer: {
    height: "100%",
    "&>.MuiGrid-container": {
      height: "100%",
    },
  },
}));
